import Axios from 'axios';
import 'core-js/stable';
import Cookies from 'js-cookie';
import React from 'react';
import ReactDOM from 'react-dom';
import {createRoot} from 'react-dom/client';
import 'regenerator-runtime/runtime';
import Shop from './component/Shop';

window.React = React;
window.ReactDOM = ReactDOM;
window.createRoot = createRoot;

window.Shop = Shop;

export const axios = Axios.create({
  baseURL: window.location.protocol + '//' + window.location.host,
  timeout: 30000
});

require('./index_mercura.scss');

export const venditshop = {
  enums: {
    preisauszeichnung: {
      GEBINDE: 0,
      STUECK: 1
    },
    zusaetzliche_preisdarstellung: {
      KEINE: 0,
      ORIGINAL_PREIS: 1,
      RABATT_FESTABZUG: 2,
      ORIGINAL_PREIS_UND_RABATT_FESTABZUG: 3
    },
    auftragsart: {
      Rechnung: 0,
      Lieferschein: 1,
      PSEUDORECHNUNG: 2,
      Sofortrechnung: 4,
      INDI: 5,
      Nachfaktura: 6,
      Sofortlieferschein: 7,
      Sofortlieferschein_ohne_Druck: 8,
      Nachfaktura_RG: 9
    }
  },
  helper: {
    getFilename: (filePath) =>{
      // Datei Pfad in seine Bestandteile zerlegen
      const parts = filePath.split('/');

      // Letztes Element des Array ist der Dateiname
      return parts[parts.length - 1];
    },
    escape_regex: (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
    fix_euro_sign: (string) => {
      if (string != null) {
        return string.split('@EUR@').join('€');
      }
      return string;
    },
    getAuftragsartByID: (id) => {
      let art = '';
      Object.entries(venditshop.enums.auftragsart).forEach(entry => {
        const [key, value] = entry;
        if (id == value) {
          art = key;
        }
      });
      return art;
    },
    isEqualsJson: (obj1, obj2) => {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      //return true when the two json has same length and all the properties has same value key by key
      return keys1.length === keys2.length && Object.keys(obj1).every(key => obj1[key] == obj2[key]);
    }
    , formatCurrency: (value, decimals = 2) => {
      try {
        if (!value && value !== 0) {
          return value;
        }
        const r = venditshop.helper.formatNumber(value, decimals);
        if (r && !r.includes('€')) {
          return r + ' €';
        }
        return value;
      } catch (e) {
        return value;
      }
    },
    formatNumber: (value, decimals = 2) => {
      try {
        const options = {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        };
        return value.toLocaleString('de-DE', options);
      } catch (e) {
        return value;
      }
    },
    sortBestellwochen: (wochen)=>{
      function compareFn(a, b) {
        if(a>40 && b <10){
          return -1;
        }
        if(a<10 && b >40){
          return 1;
        }
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      }
      return wochen.sort(compareFn);
    },
    getLastbestellwoche: (data) =>{
      let bestellwochen = [];
      Object.values(data).map((products) => {
        Object.values(products || []).map((p) => {
          if(p?.mcboerse){
            Object.values(p.mengen || []).map((p2) => {
              bestellwochen = bestellwochen.concat(Object.keys(p2));
            });
          }else if(p?.mengen){
            bestellwochen =  bestellwochen.concat(Object.keys(p.mengen));
          }
        });
      });
      bestellwochen = bestellwochen.filter(function(item, pos2, self) {
        return self.indexOf(item) == pos2 && item!= '0';
      });
      bestellwochen=venditshop.helper.sortBestellwochen(bestellwochen);
      //sort by kalender woche
      return bestellwochen[bestellwochen.length-1];
    },
    stripStringForUrl: (s) => {
      try {
        return s.replace(/%/g, ' Prozent')
          .trim()
          .replace(/\//, '-')
          .replace(/\s+/g, '-')
          .replace(/[-]+/g, '-')
          .replace(/&/g, 'und')
          .replace(/[#?=.]/g, '');
      } catch (e) {
        return s;
      }
    },
    shoppingcartTotalCount: (state) => {
      const countForType = (products) => Object.values(products).map((p) => p.menge).reduce((a, b) => a + b, 0);
      // const countForState = (state) => Object.values(state)
      //   .map((products) => countForType(products)).reduce((a, b) => a + b, 0);
      // return countForState(state);
      return Object.keys(state)
        .map((key) => {
          if (key == 'm') {
            return Object.values(state[key]).map(m => {
              return countForType(m.pos);
            }).reduce((a, b) => a + b, 0);
          } else {
            return countForType(state[key]);
          }
        }).reduce((a, b) => a + b, 0);
    },
    shoppingcartCountPos: (state) => {
      const countForType = (products) => Object.values(products).map((p) => 1).reduce((a, b) => a + b, 0);

      return Object.keys(state)
        .map((key) => {
          if (key == 'm') {
            return Object.values(state[key]).map(m => {
              return countForType(m.pos);
            }).reduce((a, b) => a + b, 0);
          } else {
            return countForType(state[key]);
          }
        }).reduce((a, b) => a + b, 0);
    },
    shoppingcartTotalAmount: (state) => {
      const amountForType = (products) => Object.values(products)
        .map((p) => {
          if (!p.individualpreis && (!p?.naturalrabatt|| p?.leergutkz==5)) {
            const menge_vk = Math.floor(p.menge);
            const menge_stk = (p.menge % 1) * 100;
            return ((p.vkp || 0).toFixed(2) * menge_vk) + ((p.vkp_stueck || 0).toFixed(2) * menge_stk);
          } else {
            return 0;
          }
        }).reduce((a, b) => a + b, 0);

      let tmp = Object.keys(state)
        .map((key) => {
          if (key == 'm') {
            return Object.values(state[key]).map(m => {
              return amountForType(m.pos);
            }).reduce((a, b) => a + b, 0);
          } else {
            return amountForType(state[key]);
          }
        }).reduce((a, b) => a + b, 0);

      return tmp;
    },
    getCurrentKVP: (p) => {
      if (!p.individualpreis) {
        const menge_vk = Math.floor(p.menge);
        const menge_stk = (p.menge % 1) * 100;
        return ((p.kvp || 0).toFixed(2) * menge_vk) + ((p.kvp_stueck || 0).toFixed(2) * menge_stk);
      } else {
        return 0;
      }
    },
    getKvpForPos: (kvp,kvp_stueck, menge) =>{
      const menge_vk = Math.floor(menge);
      const menge_stk = (menge % 1) * 100;
      return ((kvp || 0).toFixed(2) * menge_vk) + ((kvp_stueck || 0).toFixed(2) * menge_stk);
    },
    getCurrentVKP: (p) => {
      if (!p.individualpreis) {
        const menge_vk = Math.floor(p.menge);
        const menge_stk = (p.menge % 1) * 100;
        return ((p.vkp || 0).toFixed(2) * menge_vk) + ((p.vkp_stueck || 0).toFixed(2) * menge_stk);
      } else {
        return 0;
      }
    },
    shoppingcartTotalAmountKvp: (state) => {
      const amountForType = (products) => Object.values(products)
        .map((p) => {
          if (!p.individualpreis) {
            const menge_vk = Math.floor(p.menge);
            const menge_stk = (p.menge % 1) * 100;
            return ((p.kvp || 0).toFixed(2) * menge_vk) + ((p.kvp_stueck || 0).toFixed(2) * menge_stk);
          } else {
            return 0;
          }
        }).reduce((a, b) => a + b, 0);
      return Object.keys(state)
        .map((key) => {
          if (key == 'm') {
            return Object.values(state[key]).map(m => {
              return amountForType(m.pos);
            }).reduce((a, b) => a + b, 0);
          } else {
            return amountForType(state[key]);
          }
        }).reduce((a, b) => a + b, 0);
    },
    shoppingcartTotalTax: (state) => {
      const r = {};
      Object.values(state || []).map((products) => {
        Object.values(products || []).map((p) => {
          if (p?.pos && !p.individualpreis) {
            Object.values(p.pos || []).map((p) => {
              if (!p?.naturalrabatt || p?.leergutkz==5) {
                r[p.mwst] = r[p.mwst] || 0;
                const menge_vk = Math.floor(p.menge);
                const menge_stk = (p.menge % 1) * 100;
                const endpreis = ((p.vkp || 0).toFixed(2) * menge_vk) + ((p.vkp_stueck || 0).toFixed(2) * menge_stk);
                r[p.mwst] += endpreis * p.mwst / 100;
                if (p.pfand && p.pfand.length) {
                  p.pfand.forEach((pfandpos) => {
                    const t = pfandpos.pfand_gesmwst * p.menge;
                    if (r[pfandpos.mwstfaktor]) {
                      r[pfandpos.mwstfaktor] += t;
                    } else {
                      r[pfandpos.mwstfaktor] = t;
                    }
                  });
                }
              }
            });
          } else if (p && !p.individualpreis && (!p?.naturalrabatt|| p?.leergutkz==5)) {
            r[p.mwst] = r[p.mwst] || 0;
            const menge_vk = Math.floor(p.menge);
            const menge_stk = (p.menge % 1) * 100;
            const endpreis = ((p.vkp || 0).toFixed(2) * menge_vk) + ((p.vkp_stueck || 0).toFixed(2) * menge_stk);
            r[p.mwst] += endpreis * p.mwst / 100;
            if (p.pfand && p.pfand.length) {
              p.pfand.forEach((pfandpos) => {
                const t = pfandpos.pfand_gesmwst * p.menge;
                if (r[pfandpos.mwstfaktor]) {
                  r[pfandpos.mwstfaktor] += t;
                } else {
                  r[pfandpos.mwstfaktor] = t;
                }
              });
            }
          }
        });
      });
      return r;
    },
    shoppingcartTotalPfand: (state) => {
      let r = 0;
      Object.values(state).map((products) => {
        Object.values(products).map((p) => {
          if (p.pfand && p.pfand.length) {
            p.pfand.forEach((pfandpos) => {
              if (pfandpos.pfand_gespreis > 0) {
                r += pfandpos.pfand_gespreis * p.menge;
              }
            });
          }
        });
      });
      return r;
    },
    shoppingcartTotalVerguetung: (state) => {
      let r = 0;
      Object.values(state).map((products) => {
        Object.values(products).map((p) => {
          if (p.pfand && p.pfand.length) {
            p.pfand.forEach((pfandpos) => {
              if (pfandpos.pfand_gespreis < 0) {
                r += pfandpos.pfand_gespreis * p.menge;
              }
            });
          }
        });
      });
      return r;
    },
    beinhaltetBestellartikel: (state) => {
      let tmp = false;
      Object.values(state).map((products) => {
        Object.values(products).map((p) => {
          if (p.bestellartikel) {
            tmp = true;
          }
        });
      });
      return tmp;
    },
    shoppingcartWgrMinumsatz: (state) => {
      const wgrMinumsaetze = {};
      Object.values(state)
        .filter((a) => !!a.gutscheincode && a.gutscheinwarengruppen && a.gutscheinwarengruppen.length)
        .map((a) => {
          a.gutscheinwarengruppen.forEach((e) => {
            const wgr = e.warengruppe;
            const min = e.mindestumsatz;
            if (typeof wgrMinumsaetze[wgr] === 'undefined' || min > wgrMinumsaetze[wgr]) {
              wgrMinumsaetze[wgr] = min;
            }
          });
        });
      return wgrMinumsaetze;
    },
    shoppingcartWgrUmsatz: (state) => {
      const wgrUmsaetze = {};
      Object.values(state)
        .filter((a) => a.vkp)
        .map((a) => {
          const wgr = a.warengruppe;
          const sum = a.vkp * a.menge;
          if (typeof wgrUmsaetze[wgr] === 'undefined') {
            wgrUmsaetze[wgr] = sum;
          } else {
            wgrUmsaetze[wgr] += sum;
          }
        });
      return wgrUmsaetze;
    },
    checkWgrMindestumsatz: (mindestumsaetze, umsaetze) => {
      let check = true;
      Object.keys(mindestumsaetze).forEach((wgr) => {
        const minumsatz = mindestumsaetze[wgr];
        const umsatz = typeof umsaetze[wgr] !== 'undefined' ? umsaetze[wgr] : 0;
        if (umsatz < minumsatz) {
          check = false;
        }
      });
      return check;
    },
    checkEan: (eanCode) => {
      const ValidChars = '0123456789';
      for (let i = 0; i < eanCode.length; i++) {
        if (ValidChars.indexOf(eanCode.charAt(i)) === -1) {
          return false;
        }
      }
      if (eanCode.length === 8) {
        eanCode = '00000' + eanCode;
      } else if (eanCode.length !== 13) {
        return false;
      }
      const originalCheck = eanCode.substring(eanCode.length - 1);
      eanCode = eanCode.substring(0, eanCode.length - 1);
      let even = Number(eanCode.charAt(1)) +
        Number(eanCode.charAt(3)) +
        Number(eanCode.charAt(5)) +
        Number(eanCode.charAt(7)) +
        Number(eanCode.charAt(9)) +
        Number(eanCode.charAt(11));
      even *= 3;
      const odd = Number(eanCode.charAt(0)) +
        Number(eanCode.charAt(2)) +
        Number(eanCode.charAt(4)) +
        Number(eanCode.charAt(6)) +
        Number(eanCode.charAt(8)) +
        Number(eanCode.charAt(10));
      const total = even + odd;
      let checksum = total % 10;
      if (checksum !== 0) {
        checksum = 10 - checksum;
      }
      if (checksum != originalCheck) {
        return false;
      }
      return true;
    },
    formatDate: (date) => {
      const options = {year: 'numeric', month: 'long', day: 'numeric'};
      return date.toLocaleDateString('de-DE', options);
    }, formatDateShort: (date) => {
      const options = {year: 'numeric', month: 'short', day: 'numeric'};
      return date.toLocaleDateString('de-DE', options);
    }
  }
};
export const checkVisible = () => {
  // console.log('checkVisible');
  const h = window.innerHeight;
  for (const element of document.querySelectorAll('._Product')) {
    const bcr = element.getBoundingClientRect();
    const visible = bcr.top > -bcr.height && bcr.top < (h + 500);
    // console.log('visible');
    // console.log(visible);
    if (element.onVisibilityChange) {
      element.onVisibilityChange(visible);
    }
  }
};

export const resetAllCookieClicks = () => {
  Cookies.set('SliderClick', false);
  Cookies.set('ExklusivAngeboteClick', false);
};

// window.startTime = Date.now();
document.onscroll = () => {
  const h = window.innerHeight;
  for (const element of document.querySelectorAll('._Product')) {
    const bcr = element.getBoundingClientRect();
    const visible = bcr.top > -bcr.height && bcr.top < (h + 500);

    if (element.onVisibilityChange) {
      element.onVisibilityChange(visible);
    }

  }
  for (const element of document.querySelectorAll('._ProductList')) {
    if (element.onScrollEvent) {
      element.onScrollEvent();
    }
  }
};

document.ontouchmove = () => {
  document.onscroll();
};
